<template>
	<div class="acForm">
		<div class="acForm-radio-type">
			<div class="radio-label">用户性质：</div>
			<div class="radio-div" @click="switchUserType('1')">
				<i class="nsw-icon icon-radio" :class="{'checked': userType === '1'}"></i>
				<span>公司/单位</span>
			</div>
			<div class="radio-div" @click="switchUserType('2')" v-show="certifyInfo.perPass !== '1'">
				<i class="nsw-icon icon-radio" :class="{'checked': userType === '2'}"></i>
				<span>个人</span>
			</div>
		</div>
		<el-form :model="acForm" :rules="rules" ref="acForm" label-width="140px" class="acForm-form">
			<div v-if="userType === '1'">
				<el-form-item label="企业名称：" prop="entName">
					<el-input v-model="acForm.entName" placeholder="营业执照中的公司名称"></el-input>
					<i class="must">*</i>
				</el-form-item>
				<el-form-item label="统一社会信用代码：" prop="entRegNum">
					<el-input v-model="acForm.entRegNum" placeholder="营业执照中的统一社会信用代码"></el-input>
					<i class="must">*</i>
				</el-form-item>
				<div class="acForm-horizontal"></div>
				<el-form-item label="管理员姓名：" prop="perName">
					<el-input v-model="acForm.perName" placeholder="真实姓名" :disabled="certifyInfo.perPass === '1'"></el-input>
					<i class="must">*</i>
				</el-form-item>
				<el-form-item label="身份证号码：" prop="perIdNum">
					<el-input v-model="acForm.perIdNum" placeholder="身份证号码" :disabled="certifyInfo.perPass === '1'"></el-input>
					<i class="must">*</i>
				</el-form-item>
				<el-form-item label="手机号码：" prop="tel">
					<el-input v-model="acForm.tel" placeholder="手机号码"></el-input>
					<i class="must">*</i>
				</el-form-item>
			</div>
			<div v-if="userType === '2'">
				<el-form-item label="真实姓名：" prop="perName">
					<el-input v-model="acForm.perName" placeholder="真实姓名"></el-input>
					<i class="must">*</i>
				</el-form-item>
				<el-form-item label="身份证号码：" prop="perIdNum">
					<el-input v-model="acForm.perIdNum" placeholder="身份证号码"></el-input>
					<i class="must">*</i>
				</el-form-item>
			</div>

			<el-form-item>
				<el-button type="warning" class="large-warning-button" round @click="submitForm('acForm')" :disabled="certifyLoading">{{certifyLoading ? '认证中...' : '提交'}}</el-button>
			</el-form-item>
		</el-form>
		<div class="ac_error" v-show="certifyErrInfo && !certifyLoading">
			<span>认证不通过原因：</span>
			<p>{{certifyErrInfo}}</p>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import rules from './rules'
import { mapActions } from 'vuex'
export default {
	name: 'AcForm',
	props: {
		certifyInfo: Object
	},
	data () {
		return {
			userType: '1', // 1 企业 , 2 个人
			acForm: {
				entName: '',
				entRegNum: '',
				perName: '',
				perIdNum: '',
				tel: ''
			},
			certifyErrInfo: '',
			rules: { ...rules },
			certifyLoading: false
		}
	},
	created () {
		this.syncAcFormData()
		this.userType = this.$route.query.cur || '1'
	},
	methods: {
		...mapActions('certify', ['perCertify', 'entCertify']),
		submitForm (formName) {
			this.$refs[formName].validate(async (valid) => {
				if (!valid || this.certifyLoading) {
					return false
				}
				let res
				if (this.userType === '1') {
					let params = {
						entName: this.acForm.entName,
						entRegNum: this.acForm.entRegNum,
						certifyId: this.certifyInfo.certifyId || '',
						perName: this.acForm.perName,
						perIdNum: this.acForm.perIdNum,
						tel: this.acForm.tel
					}
					res = await this.entCertify(params)
				} else if (this.userType === '2') {
					let params = {
						certifyId: this.certifyInfo.certifyId || '',
						perName: this.acForm.perName,
						perIdNum: this.acForm.perIdNum
					}
					res = await this.perCertify(params)
				}
				this.$parent.getCertifyInfo()
				if (res.data.isSuccess) {
					this.certifyLoading = true
				} else {
					this.certifyErrInfo = res.data.message || '认证失败！'
					this.$router.replace({
						name: 'certify',
						query: {
							cur: this.userType
						}
					})
				}
			})
		},
		switchUserType (type) {
			if (type === this.userType) {
				return
			}
			this.userType = type
			this.$router.replace({
				name: 'certify',
				query: {
					cur: type
				}
			})
			this.certifyErrInfo = ''
			this.$refs.acForm.resetFields()
			this.syncAcFormData()
		},
		syncAcFormData () {
			for (let keys in this.acForm) {
				this.acForm[keys] = this.certifyInfo[keys] || ''
			}
			if (this.certifyInfo.status === '0') {
				this.certifyErrInfo = this.certifyInfo.failMsg
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.acForm{
	padding:38px 77px ;
}
.acForm-radio-type {
	display: flex;
	.radio-label {
		width: 140px;
		padding-right: 10px;
		text-align: right;
		margin-bottom: 22px;
	}
	.radio-div {
		margin-right: 30px;
		cursor: pointer;
		i {
			display: inline-block;
			vertical-align: middle;
			margin-right: 10px;
			&.checked{
				color: $colorA;
			}
		}
	}
}
.acForm-horizontal {
	height: 1px;
	width: 600px;
	background-color: #e8e8e8;
	margin-bottom: 22px;
}
i.must {
	display: inline-block;
	margin-left: 20px;
	color: #e80000;
	font-size: 14px;
}
.ac_error {
	margin-top: 40px;
	margin-left: 140px;
	border: 1px solid #ff4444;
	background: #ff9398;
	width: 260px;
	padding: 15px;
	span {
		display: block;
		font-weight: bold;
		color: #692626;
	}
	p {
		display: block;
		word-wrap: break-word;
		color: #692626;
	}
}
</style>
